/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_MembersInputs */

const th_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมาชิก`)
};

const en_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const ja_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバー`)
};

const zh_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成员`)
};

const es_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros`)
};

const pt_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros`)
};

const id_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota`)
};

const fr_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres`)
};

const tl_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga miyembro`)
};

const vi_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành viên`)
};

const ko_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구성원`)
};

const de_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

const ru_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Участники`)
};

const tr_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üyeler`)
};

const it_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri`)
};

const pl_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Członkowie`)
};

const uk_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учасники`)
};

const hi_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्य`)
};

const ar_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأعضاء`)
};

const ms_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahli`)
};

const bn_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সদস্য`)
};

const zh_tw2_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成員`)
};

const zh_hk2_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成員`)
};

const ur_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ارکان`)
};

const fa_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعضا`)
};

const sw_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanachama`)
};

const nl_org_members = /** @type {(inputs: Org_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leden`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Org_MembersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_members = /** @type {((inputs?: Org_MembersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_MembersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_members(inputs)
	if (locale === "ja") return ja_org_members(inputs)
	if (locale === "zh") return zh_org_members(inputs)
	if (locale === "es") return es_org_members(inputs)
	if (locale === "pt") return pt_org_members(inputs)
	if (locale === "id") return id_org_members(inputs)
	if (locale === "fr") return fr_org_members(inputs)
	if (locale === "tl") return tl_org_members(inputs)
	if (locale === "vi") return vi_org_members(inputs)
	if (locale === "ko") return ko_org_members(inputs)
	if (locale === "de") return de_org_members(inputs)
	if (locale === "ru") return ru_org_members(inputs)
	if (locale === "tr") return tr_org_members(inputs)
	if (locale === "it") return it_org_members(inputs)
	if (locale === "pl") return pl_org_members(inputs)
	if (locale === "uk") return uk_org_members(inputs)
	if (locale === "hi") return hi_org_members(inputs)
	if (locale === "ar") return ar_org_members(inputs)
	if (locale === "ms") return ms_org_members(inputs)
	if (locale === "bn") return bn_org_members(inputs)
	if (locale === "zh-TW") return zh_tw2_org_members(inputs)
	if (locale === "zh-HK") return zh_hk2_org_members(inputs)
	if (locale === "ur") return ur_org_members(inputs)
	if (locale === "fa") return fa_org_members(inputs)
	if (locale === "sw") return sw_org_members(inputs)
	if (locale === "nl") return nl_org_members(inputs)
	return en_org_members(inputs)
});